module.exports = "https://web-assets.ifttt.com/packs/media/layout/chevron-right-blue-ee8d0827.svg";